type ConfirmNoValueType = null | undefined | '';

export const confirmNoValue = (value: unknown): value is ConfirmNoValueType =>
  value === null || value === undefined || value === '';
